import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const disbursementsOverview: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursements-overview`),
};

export default disbursementsOverview;

export const disbursementsOverviewLocation: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursements-overview`),
};
